<template>
    <div>
        <div class="app-main__inner">
            <TituloComponente icono-titulo="fas fa-plus" texto-titulo="Nuevo tipo de liquidación" />
            <div class="tab-content">
                <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="main-card mb-3 card">
                                <div class="card-body">
                                    <h5 class="card-title">Datos:</h5>
                                    <form @submit.prevent="guardarTipoLiquidacion()">
                                        <float-label label="Descripción:" clase="">
                                            <input id="descripcion" v-model="tipoliquidacion.descripcion" placeholder="Ingresar una descripción..." type="text" class="form-control"/>
                                        </float-label>
                                        <button class="mt-1 btn btn-info float-right">Guardar</button>
                                    </form>                                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                               
        </div>
    </div>
</template>
<script>
import TituloComponente from '@/components/layouts/TituloComponente';
import FloatLabel from '@/components/layouts/FloatLabel';
import TipoLiquidacion from '@/models/situacionRevista';
import axios from 'axios';
export default {
    name: "NuevaTipoLiquidacion",
    components: {
        TituloComponente,
        FloatLabel,
    },
    data(){
        return{
            tipoliquidacion: new TipoLiquidacion(null, ''),
        }
    },
    methods:{
        guardarTipoLiquidacion(){
                axios.post('/tipoliquidacion',this.tipoliquidacion)
                .then(res => {
                    if(res.data.success){
                    this.$router.push({name:'ListarTipoLiquidacion'});
                    }
                })
                .catch(error => {
                    console.log(error);

                })
        }
    }
}
</script>